<template>
  <div id="CourseInfo">
    <div class="info">
      <img :src="courseInfo.cover" alt="">
      <div class="msg">
        <div class="leftBox">
          <div class="title">
            <h5>{{courseInfo.name}}</h5>
            <span v-if="courseInfo.speakerNames">{{courseInfo.speakerNames}}</span>
          </div>
        </div>
        <i v-if="!$route.query.section">
          {{amountPayable}}
          <pre>{{toPayFor_n===2?'神贝':'元'}}</pre>
        </i>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CourseInfo',
    components:{},
    props:['courseInfo','toPayFor_n','sectionList','amountPayable'],
  }
</script>
<style lang="scss" scoped>
  .info {
    padding: 20px;
    display: flex;
    background: #FBFBFB;
    border-radius: 6px;

    img {
      width: 190px;
      height: 90px;
      border-radius: 6px;
      overflow: hidden;
      margin-right: 15px;
    }

    .msg{
      flex: 1;
      display: flex;
      align-items: center;
      .leftBox{
        flex: 1;
        width: 0;
        .title {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          height: 90px;

          h5 {
            font-size: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          span {
            font-size: 16px;
          }
        }
      }
      i {
        font-size: 22px;
        color: #666666;
        display: flex;
        align-items: baseline;
        margin-left: 10px;

        pre {
          font-size: 16px;
          margin: 0;
        }
      }
    }
  }
</style>
